module.exports = __webpack_public_path__ + "static/media/delete_icon_popup.6bed29b8.svg";